import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsIframeCommentPipe } from '@shared/modules/comments/components/pipes/comment-type/is-iframe-comment.pipe';
import { IsChannelCommentPipe } from './is-channel-comment.pipe';
import { IsMailCommentPipe } from './is-mail-comment.pipe';
import { IsSystemCommentPipe } from './is-system-comment.pipe';

@NgModule({
  declarations: [IsMailCommentPipe, IsSystemCommentPipe, IsChannelCommentPipe, IsIframeCommentPipe],
  imports: [CommonModule],
  exports: [IsMailCommentPipe, IsSystemCommentPipe, IsChannelCommentPipe, IsIframeCommentPipe]
})
export class CommentTypeModule {}
